import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const DeliverableTrackingPage = lazy(() => import('./pages/DeliverableTrackingPage'));
const DeliverableVersionsPage = lazy(() => import('./pages/DeliverableVersionsPage'));
const ClientSignoffPage = lazy(() => import('./pages/ClientSignoffPage'));
const ProofOfDeliveryPage = lazy(() => import('./pages/ProofOfDeliveryPage'));

export const DeliverablesRoutes: RouteObject = {
  path: 'deliverables',
  handle: { crumb: 'Deliverables & Governance' },
  element: <ModuleGuard moduleId="projects.deliverables" />,
  children: [
    { index: true, element: <Navigate to="deliverable-tracking" replace /> },
    { path: 'deliverable-tracking', element: <DeliverableTrackingPage />, handle: { crumb: 'Deliverable Tracking' } },
    { path: 'deliverable-versions', element: <DeliverableVersionsPage />, handle: { crumb: 'Deliverable Versions' } },
    { path: 'client-signoff', element: <ClientSignoffPage />, handle: { crumb: 'Client Signoff' } },
    { path: 'proof-of-delivery', element: <ProofOfDeliveryPage />, handle: { crumb: 'Proof Of Delivery' } },
  ],
};
